export type Question = { question: string; choices: string[]; answer: number };

// Fisher–Yates over the choice order; `answer` follows the correct choice to its new index.
export function shuffleChoices(q: Question, random = Math.random): Question {
  const order = q.choices.map((_, i) => i);
  for (let i = order.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }
  return {
    question: q.question,
    choices: order.map((i) => q.choices[i]),
    answer: order.indexOf(q.answer),
  };
}
